<script setup lang="ts">
import UiButton from '@/components/UiButton/UiButton.vue'
import type { IProps } from '~/domains/career/main/components/career-main-hireRegions/career-main-hireRegions.types'

defineProps<IProps>()

</script>

<template>
  <div class="HireRegions">
    <div class="HireRegions__container">
      <div>
        <UiHeader
          v-if="header"
          :header="header"
          :subheader="subheader"
          position="left"
          header-size="h5"
          header-size-tablet="h5"
          header-size-mobile="h5"
          subheader-size="body-1"
          subheader-size-mobile="body-2"
        />
      </div>

      <div class="HireRegions__boxContainer">
        <div
          v-for="area in areas"
          :key="area.header"
          class="HireRegions__box"
        >
          <div class="HireRegions__boxWrapper">
            <img
              class="HireRegions__boxPhoto"
              :src="area.photo"
            >

            <h4 class="HireRegions__boxHeader">
              {{ area.header }}
            </h4>

            <p class="HireRegions__boxLead">
              {{ area.lead }}
            </p>
          </div>
          <UiButton
            :to="area.link"
            :target="area.target"
          >
            Poznaj
          </UiButton>
        </div>
      </div>

      <div class="HireRegions__linkContainer">
        <NuxtLink
          v-if="link"
          class="HireRegions__link"
          :to="link"
          :target="target"
        >
          {{ textLink }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.HireRegions {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 4rem 2.4rem;
  background-color: $gray-100;
  border-radius: 2.4rem;

  &__container {
    display: flex;
    flex-direction: column;
    max-width: 136rem;
    width: 100%;
  }

  &__boxContainer {
    width: 100%;
    margin: 3.2rem 0 4rem 0;
  }

  &__box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-height: unset;
    padding: 2rem 1.5rem 3.2rem 1.5rem;

    &:nth-child(1) {
      background-color: $purple-500;
      border-top-left-radius: 1.6rem;
      border-top-right-radius: 1.6rem;
    }

    &:nth-child(2) {
      background-color: $purple-400;
    }

    &:nth-child(3) {
      background-color: $purple-300;
    }

    &:nth-child(4) {
      background-color: $purple-400;
    }

    &:nth-child(5) {
      background-color: $purple-500;
      border-bottom-right-radius: 1.6rem;
      border-bottom-left-radius: 1.6rem;
    }
  }

  &__boxWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__boxPhoto {
    height: 11.2rem
  }

  &__boxHeader {
    @include h9;
    margin: 1.6rem 0 0.8rem 0;
    color: $white;
  }

  &__boxLead {
    @include body-3-medium;
    margin: 0 0 1.6rem 0;
    color: $white;
    text-align: center;
  }

  &__linkContainer {
    display: flex;
    margin: 0 auto;
  }

  &__link {
    @include body-1-medium;
    display: flex;
    color: $text-400;
    text-align: center;
    border-bottom: 1px solid $purple-400;
    cursor: pointer;
  }
}

@include atM {
  .HireRegions {
    width: 100%;
    padding: 6rem 1rem;

    &__boxContainer {
      display: flex;
      margin: 8rem 0 6.4rem 0;
    }

    &__box {
      min-height: 48.8rem;
      padding: 4.8rem 4.0rem;

      &:nth-child(1) {
        border-top-left-radius: 1.6rem;
        border-top-right-radius: 0;
        border-bottom-left-radius: 1.6rem;
      }

      &:nth-child(5) {
        background-color: $purple-500;
        border-top-right-radius: 1.6rem;
        border-bottom-right-radius: 1.6rem;
        border-bottom-left-radius: 0;
      }
    }

    &__boxPhoto {
      height: 15.1rem;
    }

    &__boxLead {
      margin: 0 0 4.8rem 0;
    }

    &__link {
      @include h9;
    }
  }
}
</style>
